module.exports = __webpack_public_path__ + "img/065-cloudy-night-1.5b671845.svg";